<script lang="ts">import { stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { CheckIcon, RemoveIcon } from "@infinitro/icons";
import { Input } from "@infinitro/input";
import { invalidateIdentifierResolution, stateIdentifierResolved, stateUsername, submit } from "../state";
import { isValidLoginUsername, isValidRegisterUsername, LOGIN_USERNAME_MAX, REGISTER_USERNAME_MAX } from "../utils/passwordCredentials";
export let registerRules = true;
let element = null;
let valid = false;
let touched = false;
let autofillLocked = true;
$: useFlat = $stateUi.modal?.modalStyle === "flat";
$: maxLength = registerRules ? REGISTER_USERNAME_MAX : LOGIN_USERNAME_MAX;
// stateIdentifierResolved is also set when PreLogin redirects an unknown identifier to
// signup, or when a second identifier is still needed - neither means THIS field was
// resolved, so only lock it outside those cases (plain login identifier resolution).
$: confirmed = $stateIdentifierResolved && !registerRules;
const unlockAutofill = () => {
	autofillLocked = false;
};
const onInput = (value) => {
	touched = true;
	const trimmed = value.trim();
	valid = registerRules ? isValidRegisterUsername(trimmed) : isValidLoginUsername(trimmed);
	stateUsername.set(trimmed);
};
const onKeydown = (event) => {
	if (event.key !== "Enter") return;
	event.preventDefault();
	submit(event);
};
const onRemove = (event) => {
	event.preventDefault();
	event.stopPropagation();
	invalidateIdentifierResolution();
	stateUsername.set("");
	// Removing unlocks the field for typing right away - without this it stays readonly
	// (autofill protection) until the player clicks into it a second time.
	autofillLocked = false;
	element?.focus();
};
</script>

<label class="field" class:field-flat={useFlat} for="registerUsername">
	<span class="label">{$t(Verbiage.username)} *</span>
	<div class="input-wrap">
		<Input
			type="text"
			name="register-username"
			id="registerUsername"
			autocomplete="off"
			readonly={autofillLocked}
			onFocus={unlockAutofill}
			placeholder={$t(Verbiage.enter_your_username)}
			required
			maxlength={maxLength}
			bind:element
			bind:value={$stateUsername}
			{onInput}
			{onKeydown}
			disabled={confirmed}
			customBorderRadius={useFlat ? '8px' : undefined}
			inputClasses={useFlat ? 'auth-flat-input-el' : ''}
			error={touched && !valid}
			message={touched && !valid
				? registerRules
					? $t(Verbiage.username_format_hint)
					: $t(Verbiage.username_must_be_letters_and_numbers)
				: ''}
		/>
		{#if confirmed}
			<span class="trailing-icon">
				<button type="button" class="remove" on:click={onRemove}><RemoveIcon /></button>
				<span class="check"><CheckIcon /></span>
			</span>
		{/if}
	</div>
</label>

<style>
	.field {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 0.5rem
}
	.field-flat {
    padding-top: 0px;
    padding-bottom: 0px
}
	.label {
    margin-top: 0.5rem;
    font-size: 0.75rem;
    line-height: 1rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.025em;
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}
	.input-wrap {
    position: relative;
    width: 100%
}
	.trailing-icon {
    pointer-events: auto;
    position: absolute;
    top: 4px;
    right: 0px;
    display: flex;
    padding-right: 0.5rem
}
	.check {
    position: absolute;
    top: 14px
}
	.remove {
    cursor: pointer
}
</style>
